import { Puzzle, Settings, SlidersHorizontal } from 'lucide-react';
import type { NavItem } from '@os/ui';

/** Host chrome on every OS app. Addon nav is inserted *before* this group (`mergeAddonNav`). The top bar renders links only. */
export const APP_NAV: NavItem[] = [
  { group: 'App' },
  { to: '/presets', label: 'Presets', icon: SlidersHorizontal, end: true },
  { to: '/settings/addons', label: 'Add-ons', icon: Puzzle, end: true },
  { to: '/settings', label: 'Settings', icon: Settings, end: true },
];
